<script lang="ts">
  import { link, Link, navigate } from "svelte-navigator";
  import {
    Button,
    Icon,
    Nav,
    Navbar,
    NavbarBrand,
    NavItem,
    NavLink,
  } from "sveltestrap";
  import type { User } from "../Model/User";
  import { endSession, getCurrentUser } from "../services/session";
  import UserModal from "./UserModal.svelte";

  let perfilUser: User;
  let user: User = getCurrentUser()

  let openSideMenu = true;
  let showAllLetter = true;

  const toggleSideMenu = () => {
    openSideMenu = !openSideMenu
    setTimeout(() => {
      showAllLetter = !showAllLetter;
    }, 400);
  } 

  function logOut() {
    if (confirm("¿Estas seguro de cerrar sesión?")) {
      endSession();
      navigate("login", { replace: true });
    }
  }

  function onProfileClick(): void {
    perfilUser = getCurrentUser();
  }
</script>

<div class="app-wrapper">
  <div class="side-menu text-start" class:open={openSideMenu}>
    <div class="box-img">
      {#if openSideMenu}
        <h4>BananaCop</h4>
      {:else}
        <h5>BCOP</h5>
      {/if}
    </div>
    <Nav class="ms-auto" navbar>
      <NavItem>
        <Link class="nav-link" to="/" style="color: white"
          ><Icon name="circle" />
          {#if showAllLetter && openSideMenu}
            Inicio
          {/if}
        </Link>
      </NavItem>
      <NavItem>
        <Link class="nav-link" to="/mapas" style="color: white"
          ><Icon name="map-fill" />
          {#if showAllLetter && openSideMenu}
            Mapas
          {/if}
        </Link>
      </NavItem>
      <NavItem>
        <Link class="nav-link" to="/diligencias" style="color: white"
          ><Icon name="file-text-fill" />
          {#if showAllLetter && openSideMenu}
            Diligencias
          {/if}
        </Link>
      </NavItem>
      <NavItem>
        <Link class="nav-link" to="/register" style="color: white"
          ><Icon name="newspaper" />
          {#if showAllLetter && openSideMenu}
            Registros
          {/if}
        </Link>
      </NavItem>
      <NavItem>
        <Link class="nav-link" to="/antecedentesExternos" style="color: white"
          ><Icon name="newspaper" />
          {#if showAllLetter && openSideMenu}
            Ant. Externos
          {/if}
        </Link>
      </NavItem>
      <NavItem>
        <Link class="nav-link" to="/detenidos" style="color: white"
          ><Icon name="newspaper" />
          {#if showAllLetter && openSideMenu}
            Detenidos
          {/if}
        </Link>
      </NavItem>
      <NavItem>
        <Link class="nav-link" to="/objetosPerdidos" style="color: white"
          ><Icon name="newspaper" />
          {#if showAllLetter && openSideMenu}
            Obj. Perdidos
          {/if}
        </Link>
      </NavItem>
      <NavItem>
        <Link class="nav-link" to="/sinIdentificar" style="color: white"
          ><Icon name="newspaper" />
          {#if showAllLetter && openSideMenu}
            Sin identificar
          {/if}
        </Link>
      </NavItem>
      <NavItem>
        <Link class="nav-link" to="/vehiculos" style="color: white"
          ><Icon name="truck" />
          {#if showAllLetter && openSideMenu}
            Vehiculos
          {/if}
        </Link>
      </NavItem>
      <NavItem>
        <Link class="nav-link" to="/terceros" style="color: white"
          ><Icon name="list-ol" />
          {#if showAllLetter && openSideMenu}
            Terceros
          {/if}
        </Link>
      </NavItem>
      {#if user.type.id == 4 || user.type.id == 3}
        <NavItem>
          <Link class="nav-link" to="/usuarios" style="color: white"
            ><Icon name="people-fill" />
            {#if showAllLetter && openSideMenu}
              Usuarios
            {/if}
          </Link>
        </NavItem>
      {/if}
      <NavItem>
        <NavLink on:click={onProfileClick} style="color: white"
          ><Icon name="person-badge" />
          {#if showAllLetter && openSideMenu}
            Perfil
          {/if}
        </NavLink>
      </NavItem>
      {#if user.type.id == 4 || user.type.id == 3}
        <NavItem>
          <Link class="nav-link" to="/signer" style="color: white"
            ><Icon name="vector-pen" />
            {#if showAllLetter && openSideMenu}
              Firmante
            {/if}
          </Link>
        </NavItem>
      {/if}
      {#if user.type.id == 4 || user.type.id == 3}
        <NavItem>
          <Link class="nav-link" to="/files" style="color: white"
            ><Icon name="files" />
            {#if showAllLetter && openSideMenu}
              Archivos.
            {/if}
          </Link>
        </NavItem>
      {/if}
      {#if user.type.id == 4 || user.type.id == 3}
        <NavItem>
          <Link class="nav-link" to="/settings" style="color: white"
            ><Icon name="tools" />
            {#if showAllLetter && openSideMenu}
              Config.
            {/if}
          </Link>
        </NavItem>
      {/if}
      <NavItem>
        <NavLink on:click={logOut} style="color: white"
          ><Icon name="arrow-bar-right" />
          {#if showAllLetter && openSideMenu}
            Salir
          {/if}
        </NavLink>
      </NavItem>
    </Nav>
  </div>
  <div class="main" id="main">
    <Navbar color="primary" dark expand="md" style="background-color: #008ACC !important;">
      <Button class="button-header" color="light" on:click={toggleSideMenu}>
        <Icon name="list" />
      </Button>
    </Navbar>
    <slot />
  </div>
</div>

<UserModal user={perfilUser} />

<style lang="scss">
  .app-wrapper {
    height: 100vh;
    display: flex;
  }

  .side-menu {
    width: 60px;
    transition: width 0.5s;
    background-color: #008ACC;
    &.open {
      width: 150px;
    }

    :global(i){
      color: #fff !important;
    }

    :global(li){
     padding-left: 20px !important;
    }
  }

  :global(.accordion-button){
    background-color: #F4F4F4 !important;
  }

  .main {
    flex: 1 1 0;

    :global(.button-header){
      background-color: #fff !important;
    }
  }

  .box-img {
    background-color: #008ACC;
    color: #fff;
    display: flex;
    height: 54px;
    margin-bottom: 12px;
    padding-top: 5px;
    align-items: center;
    justify-content: center;
  }

  :global(.main) {
    overflow-x: hidden;
  }

  :global(.navbar) {
    position: fixed !important;
    width: 100%;
    z-index: 4;
  }

  :global(.main > .container-fluid) {
    padding-top: 70px !important;
    padding-bottom: 20px !important;
  }

  @media (max-width: 600px) {
    .side-menu  {
      display: none;
    }
  }
</style>
